module.exports = __webpack_public_path__ + "static/tactics_and_analysis-9256c45adc9bfb95e02b3027903fca27.mp4";